import React from 'react';
import ScrollToTop from './ScrollToTop';
import ThemeToggleButton from './ThemeToggleButton';
import '../styles/PlatformIntro.css';

const PlatformIntro = () => {
  return (
    <>
      <div className="intro-container">
        <header className="intro-hero">
          <h1>Struggle</h1>
          <p className="hero-tagline">하나의 이슈를, 다양한 시각으로.</p>
          <p className="subtitle">
            Struggle은 사회적 이슈에 대한 서로 다른 언론의 관점을 한눈에 비교할 수 있는 뉴스 큐레이션 플랫폼입니다. 사람마다
            보고 싶은 뉴스만 보게 되는 현상을 줄이고, 더 균형 잡힌 정보 소비를 돕기 위해 만들어졌습니다.
          </p>
        </header>

        <main className="intro-main">
          <section className="context-section">
            <div className="context-block">
              <h2>왜 Struggle인가</h2>
              <p>
                오늘날 뉴스 소비는 개인의 성향에 따라 극단적으로 편향되는 경향이 있습니다. 같은 사건이라도 각 언론은 서로 다른
                프레임과 어조로 다루며, 사용자는 자신이 동의하는 관점만 접하게 됩니다.
              </p>
              <p>
                Struggle은 하나의 이슈에 대해 다양한 시각을 연결함으로써, 사용자가 직접 판단하고 생각할 수 있는 환경을 만드는 것을
                목표로 합니다.
              </p>
            </div>
            <div className="values-block">
              <h3>우리가 지키는 가치</h3>
              <ul>
                <li>균형 있는 정보 소비를 통해 사회적 분열을 완화합니다.</li>
                <li>서로 다른 시각이 공존하고 이해될 수 있도록 돕습니다.</li>
                <li>AI를 활용하되, 건전한 뉴스 접근 경험을 최우선으로 합니다.</li>
              </ul>
            </div>
          </section>

          <section className="features-section">
            <h2>지금 제공하는 기능</h2>
            <div className="features-grid">
              <div className="feature-card">
                <h3>이슈 기반 뉴스 탐색</h3>
                <p>주간·일간 단위로 주요 사회 이슈를 자동 수집하고, 최신 뉴스를 함께 보여줍니다.</p>
              </div>
              <div className="feature-card">
                <h3>다양한 시각 비교</h3>
                <p>하나의 이슈에 대해 서로 다른 언론사의 기사와 사설을 나란히 제시합니다.</p>
              </div>
              <div className="feature-card">
                <h3>언론사별 성향 정보</h3>
                <p>언론사의 정치적 성향과 기본 정보를 한눈에 확인하며 기사 맥락을 이해할 수 있습니다.</p>
              </div>
              <div className="feature-card">
                <h3>콘텐츠 요약 및 정리</h3>
                <p>AI가 주요 논점과 입장을 자동 요약하도록 준비 중입니다.</p>
              </div>
            </div>
          </section>

          <section className="vision-section">
            <h2>Struggle이 향하는 방향</h2>
            <div className="vision-grid">
              <div className="vision-card">
                <strong>단기</strong>
                <p>주요 이슈와 기사 데이터를 안정적으로 수집하고, 언론별 시각 비교 기능을 완성합니다.</p>
              </div>
              <div className="vision-card">
                <strong>중기</strong>
                <p>AI 요약과 자동 클러스터링으로 이슈 간 관계를 시각화하고 탐색 경험을 강화합니다.</p>
              </div>
              <div className="vision-card">
                <strong>장기</strong>
                <p>사용자 맞춤형 이슈 추천을 통해 균형 잡힌 뉴스 추천 시스템으로 발전합니다.</p>
              </div>
            </div>
          </section>
        </main>

        <footer className="intro-footer">
          <p className="footer-note">
            Struggle은 다양한 시각이 공존하는 뉴스 환경을 만들기 위해 계속해서 검증하고 개선하고 있습니다. 기능과 방향성에 대한
            의견을 언제든지 보내주세요.
          </p>
        </footer>
      </div>
      <ThemeToggleButton />
      <ScrollToTop />
    </>
  );
};

export default PlatformIntro;
